<main class="main">
  <div class="page-container">
    <app-header *ngIf="!hideHeaderFooter"></app-header>
    <router-outlet></router-outlet>
  </div>

  <ng-template #loading *ngIf="isLoading">
    <div class="loader-overlay">
      <div class="spinner"></div>
      <p>Loading application...</p>
    </div>
  </ng-template>
</main>